export default __webpack_public_path__ + "static/media/Saucy.e96395ee.mp3";